import React from "react";
import AddressLink from "../../components/AddressLink";
import { formatDateString } from "../../utils";
import { FAITH_STATE_STYLES } from "./constants";

export default function TeacherDetailInfoSection({ teacher, userProfile }) {
  const currentMemberRole = userProfile?.memberRole;
  const myUid = userProfile?.uid || userProfile?.id;
  const isLinkedUser = myUid && teacher.linkedUserId && String(teacher.linkedUserId) === String(myUid);
  const isMyProfile = isLinkedUser;
  const shouldMask = currentMemberRole === "teacher" && !isMyProfile;

  return (
    <div className="w-full space-y-1 mb-8">
      <h3 className="text-xl font-bold text-gray-900 mb-4 px-1">교사 정보</h3>

      <div className="flex justify-between items-center py-4 px-1 border-b border-gray-50">
        <span className="text-gray-500 font-medium text-base">생년월일</span>
        <span className="text-gray-900 font-bold text-xl">
          {shouldMask ? <span className="blur-[5px] select-none text-gray-400 bg-gray-100 rounded px-1">1999-01-01</span> : (teacher.birth ? formatDateString(teacher.birth) : "-")}
        </span>
      </div>

      <div className="flex justify-between items-center py-4 px-1 border-b border-gray-50">
        <span className="text-gray-500 font-medium text-base">연락처</span>
        <span className="text-gray-900 font-bold text-xl">{teacher.phone || "-"}</span>
      </div>

      <div className="flex justify-between items-center py-4 px-1 border-b border-gray-50">
        <span className="text-gray-500 font-medium text-base">학교/직장</span>
        <span className="text-gray-900 font-bold text-lg">{shouldMask ? <span className="blur-[5px] select-none text-gray-400 bg-gray-100 rounded px-1">비공개 학교정보</span> : (teacher.school || "-")}</span>
      </div>

      <div className="flex justify-between items-center py-4 px-1 border-b border-gray-50 text-right min-w-0">
        <span className="text-gray-500 font-medium text-base shrink-0">주소</span>
        <span className="text-gray-900 font-bold text-lg text-right truncate pl-4">
          {shouldMask ? (
            <span className="blur-[5px] select-none text-gray-400 bg-gray-100 rounded px-1">대한민국 어딘가에 거주중입니다</span>
          ) : (
            teacher.address ? <AddressLink address={teacher.address} className="font-bold" /> : "-"
          )}
        </span>
      </div>

      <div className="flex justify-between items-center py-4 px-1 border-b border-gray-50">
        <span className="text-gray-500 font-medium text-base">신앙상태</span>
        {shouldMask ? (
          <span className="text-gray-900 font-bold text-lg blur-[5px] select-none text-gray-400 bg-gray-100 rounded px-1">신앙상태</span>
        ) : (
          <span className={`font-bold text-lg px-4 py-1.5 rounded-xl border min-w-[80px] text-center inline-block shadow-sm ${FAITH_STATE_STYLES[teacher.faithState] || "bg-gray-50 text-gray-800 border-gray-100"}`}>
            {teacher.faithState || "-"}
          </span>
        )}
      </div>
    </div>
  );
}
